import api from "../../../services/api";

const isSafeId = (value) => /^\d+$/.test(String(value));

/**
 * Download em 2 passos (token de curto prazo). A aba é aberta ANTES do await
 * para não ser bloqueada; o token vive só nesta variável local.
 * `parts` = { occurrenceId, followUpId, attachmentId }.
 */
export async function openFollowUpAttachment({ occurrenceId, followUpId, attachmentId }) {
  if (![occurrenceId, followUpId, attachmentId].every(isSafeId)) {
    throw new Error("Anexo inválido.");
  }
  const path = `/ocorrencias/${encodeURIComponent(occurrenceId)}/andamentos/${encodeURIComponent(
    followUpId
  )}/anexo/${encodeURIComponent(attachmentId)}`;
  const newTab = window.open("", "_blank");
  try {
    const { data } = await api.get(`${path}/token`);
    const url = `${process.env.REACT_APP_BACKEND_URL}${path}?token=${encodeURIComponent(data.token)}`;
    if (newTab) {
      newTab.location.href = url;
      newTab.opener = null;
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  } catch (err) {
    if (newTab) newTab.close();
    throw err;
  }
}
